module.exports = __webpack_public_path__ + "static/pitchfork-wilco-zoom-f503d62c4e3c562490ff3765681fde4b.jpg";